import getEnrichedTextInMarkdown from '@lib/utilities/enrichTextInMarkdown/getEnrichedTextInMarkdown'
import convertMarkdownToHtml from '@lib/utilities/text/convertMarkdownToHtml'

export type FaqToRender = {
  answer: string
  id: number
  question: string
  source?: string
}

export type FaqEntity = {
  '@type': 'Question'
  'acceptedAnswer': {
    '@type': 'Answer'
    'text': string
  }
  'name': string
}
export function buildFaqEntity(faq: FaqToRender): FaqEntity {
  const answerAsHtml = convertMarkdownToHtml(
    getEnrichedTextInMarkdown(faq.answer),
  )

  return {
    '@type': 'Question',
    'acceptedAnswer': {
      '@type': 'Answer',
      'text': answerAsHtml,
    },
    'name': faq.question,
  }
}
